<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editProject') }}</h1>
      <div class="form-container">
        <ProjectForm @save="save"
                   :edit-mode="true"
                   :project-data="projectData">
        </ProjectForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import ProjectForm from '@/components/ProjectForm'

  export default {
    components: {
      DashboardLayout,
      ProjectForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Project/update', {
          project: form,
          projectId: this.$route.params.projectId
        }).then(() => this.$router.go(-1))
      }
    },
    mounted() {
      this.$store.dispatch('Project/getProject', this.$route.params.projectId)
    },
    computed: {
      ...mapState('Project', ['project']),
      projectData() {
        return {
          ...this.project,
          plan_start_date: new Date(this.project.plan_start_date),
          plan_end_date: new Date(this.project.plan_end_date),
          fact_start_date: this.project.fact_start_date ? new Date(this.project.fact_start_date) : null,
          fact_end_date: this.project.fact_end_date ? new Date(this.project.fact_end_date) : null
        }
      },
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {
            name: 'projectDetail', path: {
              name: 'projectDetail',
              params: {projectId: this.$route.params.projectId}
            }
          },
          {name: 'editProject'}
        ]
      }
    }
  }
</script>